var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 9C13.41 9 14.2425 8.16 14.2425 7.125C14.2425 6.09 13.41 5.25 12.375 5.25C11.8777 5.25 11.4008 5.44754 11.0492 5.79917C10.6975 6.15081 10.5 6.62772 10.5 7.125C10.5 7.62228 10.6975 8.09919 11.0492 8.45083C11.4008 8.80246 11.8777 9 12.375 9V9ZM6.75 8.25C7.995 8.25 8.9925 7.245 8.9925 6C8.9925 4.755 7.995 3.75 6.75 3.75C5.505 3.75 4.5 4.755 4.5 6C4.5 7.245 5.505 8.25 6.75 8.25ZM12.375 10.5C11.0025 10.5 8.25 11.19 8.25 12.5625V14.25H16.5V12.5625C16.5 11.19 13.7475 10.5 12.375 10.5ZM6.75 9.75C5.0025 9.75 1.5 10.6275 1.5 12.375V14.25H6.75V12.5625C6.75 11.925 6.9975 10.8075 8.5275 9.96C7.875 9.825 7.245 9.75 6.75 9.75Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWhite);
export default __webpack_public_path__ + "static/media/user-white.f4d26efaa7cd5a9c6185eae0e02eb3f6.svg";
export { ForwardRef as ReactComponent };